"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Pin = function Pin(props) {
  return _react2.default.createElement(
    "svg",
    _extends({ width: 24, height: 36, viewBox: "0 0 24 36" }, props),
    _react2.default.createElement("path", {
      d: "M21.74 11.897C21.74 6.431 17.344 2 11.92 2 6.497 2 2.1 6.431 2.1 11.897s9.82 20.942 9.82 20.942 9.82-15.476 9.82-20.942",
      stroke: "#FFF",
      strokeWidth: 3,
      fill: "#00",
      fillRule: "evenodd"
    })
  );
};

exports.default = Pin;
Pin.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Pin"
};


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/icons/Pin.js
// module id = 628
// module chunks = 0